import React from 'react';
import { Routes, Route } from 'react-router-dom';
import MainLayout from 'layouts/MainLayout';
import SimpleLayout from 'layouts/SimpleLayout';

// Import vendor views
import VendorRegistration from 'views/vendor-registration';
import VendorDashboard from 'views/vendor-dashboard';
import VendorDocuments from 'views/vendor-documents';
import VendorProfile from 'views/vendor-profile';
import TermsConditions from 'views/terms-conditions';
import Login from 'views/login';
import DocumentSubmitted from 'views/DocumentSubmitted';

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      
      <Route path="/register" element={
        <SimpleLayout title="Tangram Interiors Vendor Registration" subtitle="Complete your vendor registration to join our partner network">
          <VendorRegistration />
        </SimpleLayout>
      } />
      
      <Route path="/" element={
        <SimpleLayout title="Tangram Interiors Vendor Registration" subtitle="Complete your vendor registration to join our partner network">
          <VendorRegistration />
        </SimpleLayout>
      } />
      
      <Route path="/dashboard" element={
        <MainLayout title="Tangram Vendor Dashboard" subtitle="Welcome to your vendor portal">
          <VendorDashboard />
        </MainLayout>
      } />
      
      <Route path="/documents" element={
        <MainLayout title="Document Library" subtitle="Manage contracts, specifications, and submissions">
          <VendorDocuments />
        </MainLayout>
      } />
      
      <Route path="/profile" element={
        <MainLayout title="Vendor Profile" subtitle="Manage your company information and capabilities">
          <VendorProfile />
        </MainLayout>
      } />
      
      <Route path="/terms" element={
        <MainLayout title="Terms & Conditions" subtitle="Review and acknowledge platform terms">
          <TermsConditions />
        </MainLayout>
      } />
      
      <Route path="/document-submitted" element={<DocumentSubmitted />} />
    </Routes>
  );
};

export default AppRoutes; 